<template>
  <div style="font-family: Raleway, sans-serif; padding: 10px 0;">
    <table justify="center"
      style="width: 100% !important; border-collapse: collapse; font-size: 10px;"
      border="1"
      cellspacing="0"
      cellpadding="6"
      id="tableTraffic"
      v-if="showTableData && stavke.length > 0">
      <thead>
        <tr :class="['header', 'naslov']"
          style="text-align: center">
          <th colspan="11" style="padding: 8px; font-size: 11px;">Artikli</th>
        </tr>
      </thead>
      <tbody>
        <tr :class="['header', 'naslov']"
          style="font-weight: bold; text-align: left; font-size: 10px;">
          <th style="padding: 6px; min-width: 100px;">Artikl</th>
          <th style="padding: 6px; min-width: 45px;">Kol.</th>
          <th style="padding: 6px; min-width: 40px;">J.mj.</th>
          <th style="padding: 6px; min-width: 55px;">Nab.cij.</th>
          <th style="padding: 6px; min-width: 55px;">Rabat(%)</th>
          <th style="padding: 6px; min-width: 55px;">Cijena</th>
          <th style="padding: 6px; min-width: 60px;">Ukupno</th>
          <th style="padding: 6px; min-width: 50px;">PDV(%)</th>
          <th style="padding: 6px; min-width: 60px;">Predporez</th>
          <th style="padding: 6px; min-width: 55px;">Brutto</th>
          <th style="padding: 6px; min-width: 40px;">Pn</th>
        </tr>
        <tr v-for="item in stavke.filter(i => i.id !== '-1')"
          :key="item.id"
          style="font-size: 10px;">
          <td style="padding: 6px;">{{ item.name }}</td>
          <td style="padding: 6px; text-align: right;">
            {{
              viewType === "pdf"
                ? formatCurrency(item.quantity, 1)
                : item.quantity
            }}
          </td>
          <td style="padding: 6px;">{{ item.measureUnit }}</td>
          <td style="padding: 6px; text-align: right;">
            {{
              viewType === "pdf"
                ? formatCurrency(item.purchasePrice)
                : item.purchasePrice / 100
            }}
          </td>
          <td style="padding: 6px; text-align: right;">
            {{
              viewType === "pdf"
                ? formatCurrency(item.supplierRebate)
                : item.supplierRebate / 100
            }}
          </td>
          <td style="padding: 6px; text-align: right;">
            {{
              viewType === "pdf"
                ? formatCurrency(item.totalPriceWithRabat)
                : item.totalPriceWithRabat / 100
            }}
          </td>
          <td style="padding: 6px; text-align: right;">
            {{
              viewType === "pdf"
                ? formatCurrency(item.totalPriceNoPdv)
                : item.totalPriceNoPdv / 100
            }}
          </td>
          <td style="padding: 6px; text-align: right;">
            {{
              viewType === "pdf"
                ? formatCurrency(item.pdv)
                : item.pdv / 100
            }}
          </td>
          <td style="padding: 6px; text-align: right;">
            {{
              viewType === "pdf"
                ? formatCurrency(item.inputTax)
                : item.inputTax / 100
            }}
          </td>
          <td style="padding: 6px; text-align: right;">
            {{
              viewType === 'pdf'
                ? formatCurrency(item.inputTax + item.totalPriceNoPdv)
                : (item.inputTax + item.totalPriceNoPdv) / 100
            }}
          </td>
          <td style="padding: 6px; text-align: right;">
            {{
              viewType === "pdf"
                ? formatCurrency(item.refundPrice)
                : item.refundPrice / 100
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  components: {
  },
  inject: ['showMsgBox', 'showLoader', 'hideLoader', 'showAlert'],
  props: {
    deliveryNoteManualData: Array,
    stavke: Array,
    showTableData: Boolean,
    viewType: String
  },
  data: () => ({
    currency: 'EUR'
  }),
  async mounted () {
  },
  methods: {
    formatCurrency (item, divider = 100) {
      return this.$options.filters
        .money(item, divider, this.currency)
        .replace('€', '')
    }
  }
}
</script>
<style scoped>
.enabledbutton {
  background-color: #2c97c5 !important;
  border-color: #2c97c5 !important;
  color: white;
  font-weight: 700;
}

.naslov {
  background-color: #d3d3d3;
  border: 1px solid black;
}

.selectedrow-456 {
  background-color: #2c97c5 !important;
  border-color: #2c97c5 !important;
  color: white;
  font-weight: 700;
}

.createDelivery>>>.vm--modal {
  border-radius: 25px !important;
}

.editDelivery>>>.vm--modal {
  border-radius: 25px !important;
}
</style>
